<template>
  <div>
    <div class="dep-create-form__section">
      <div class="dep-create-form__section-title">
        {{ $t('orgs.subdivision_data') }} <span class="required-icon">*</span>
      </div>
      <el-row :gutter="20">
        <el-col :md="12" :lg="14">
          <el-input v-bind:class="{ showLabel: depData.name || error.name.invalid, error: error.name.invalid }"
                    :placeholder="$t('labels.title')"
                    @blur="capitalize('name')"
                    v-model="depData.name">
            <label v-if="error.name.invalid"
                   class="label-error"
                   slot="prefix">
              {{ error.name.message }}
            </label>
            <label v-else
                   slot="prefix">{{ $t('labels.title') }}</label>
          </el-input>
        </el-col>
        <el-col :md="12" :lg="10">
          <el-input v-bind:class="{ showLabel: depData.abbr || error.abbr.invalid, error: error.abbr.invalid }"
                    :placeholder="$t('labels.short_title')" v-model="depData.abbr">
            <label v-if="error.abbr.invalid"
                   class="label-error"
                   slot="prefix">
              {{ error.abbr.message }}
            </label>
            <label v-else
                   slot="prefix">{{ $t('labels.short_title') }}</label>
          </el-input>
        </el-col>
      </el-row>
      <!-- <div class="dep-create-form__section-title">
        {{ $t('orgs.director') }}
      </div>
      <div class="dep-create-form-chief" v-if="userChief">
        <avatar :upic="userChief.getUpic()"
                :name="userChief.getLastName()"
                size="small">
        </avatar>
        <div class="dep-create-form-chief__name">
          {{userChief.getFullName()}}
        </div>
        <div class="dep-create-form-chief__cancel" @click="clearChief">{{ $t('labels.change') }}</div>
      </div>
      <chief-find v-else @selected="selectChief($event)" ref="chiefFind"></chief-find> -->
      <div class="dep-create-form__section-title">
        {{ $t('orgs.is_part_of') }} <span class="required-icon">*</span>
      </div>
      <div v-if="error.parent.invalid"
           class="dep-create-form__field-error">
        {{ error.parent.message }}
      </div>
      <tree-select v-if="!isHeadOrg"
                   @checked="checkParent"
                   @showPopover="getDepList"
                   :placeholder="$t('labels.organization_structure')"
                   :defaultCheckedKeys="[parent]"
                   :data="depList"
                   nodeKey="id"
                   ref="tree">
      </tree-select>
      <div class="dep-create-form-head-org">
        <el-checkbox @change="setHeadOrg" v-model="isHeadOrg">
          {{ $t('orgs.top_level_org') }}
        </el-checkbox>
      </div>
    </div>

    <div class="dep-create__nav-buttons">
      <el-button type="primary"
                 @click="next">{{ $t('orgs.add_subdivision') }} <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
  </div>
</template>
<script>
  import avatar from 'src/components/Avatar/avatar.vue'
  import ChiefFind from '../chiefFind';
  import TreeSelect from 'src/components/TreeSelect/TreeSelect.vue'
  import _ from 'lodash'
  import capitalize from 'src/filters/capitalize'

  export default {
    components: {
      ChiefFind,
      avatar,
      TreeSelect
    },
    props: {
      parent: String
    },
    data () {
      return {
        depList: [],
        userChief: null,
        isHeadOrg: false,
        depData: {
          name: '',
          abbr: '',
          parent_id: null
        },
        orgParent: null,
        error: {
          name: {
            invalid: false,
            message: ''
          },
          abbr: {
            invalid: false,
            message: ''
          },
          chief: {
            invalid: false,
            message: ''
          },
          parent: {
            invalid: false,
            message: ''
          }
        }
      }
    },
    methods: {
      capitalize (path) {
        this.depData[path] = capitalize(this.depData[path])
      },
      async getDepList () {
        let list = await this.$store.dispatch('orgs/loadRawOrgList')
        let tree = this.$store.getters['orgs/getRawTree'](list)
        this.depList = tree;
      },
      checkParent (data, checked) {
        this.depData.parent_id = data.id
        this.resetError()
      },
      async setParent () {
        let idRegExp = /^[a-f0-9]{24}$/;
        if (idRegExp.test(this.parent)) {
          try {
            await this.$store.dispatch('orgs/loadOrg', this.parent)
            this.depData.parent_id = this.parent;
          } catch (error) {
            console.error('LOG: setParent -> error', error)
          }
        }
      },
      isStepValid () {
        this.validate();

        let error = this.error;
        let isValid = true;
        for (let item in error) {
          if (this.error[item].invalid === true) {
            isValid = false;
          }
        }
        return isValid;
      },
      setError (key, message) {
        this.error[key].invalid = true;
        this.error[key].message = message;
      },
      validate () {
        if (!this.depData.name) {
          this.setError('name', this.$t('labels.required_field'))
        }

        if (!this.depData.abbr) {
          this.setError('abbr', this.$t('labels.required_field'))
        }

        if (this.depData.parent_id === null) {
          this.setError('parent', this.$t('orgs.select_org_to_which_subdivision_belongs'))
        }
      },
      resetError () {
        let error = this.error;

        for (let item in error) {
          this.error[item].invalid = false;
          this.error[item].mesage = '';
        }
      },
      next () {
        if (this.isStepValid()) {
          this.$emit('getData', this.depData)
          this.$emit('setPageTitle', this.depData.name)
          this.$emit('setOrgParent', this.orgParent)
          this.$emit('nextStep')
          this.$root.$emit('resetScroll')
        }
      },
      selectChief (data) {
        this.userChief = data
        this.$set(this.depData, 'chief', data.getId())
      },
      clearChief () {
        this.userChief = null
        this.$delete(this.depData, 'chief')
      },
      setHeadOrg () {
        this.resetError()
        if (this.isHeadOrg) {
          this.depData.parent_id = ''
        } else {
          this.depData.parent_id = null
        }
      },
      resetData () {
        this.resetError()
        if (this.$refs.chiefSearch) {
          this.$refs.chiefSearch.clearQuery()
        }
        this.userChief = null
        this.getDepList()
        if (this.isHeadOrg) {
          this.isHeadOrg = false;
        } else {
          this.$refs.tree.reset();
        }

        this.orgParent = ''

        this.depData = {
          name: '',
          abbr: ''
        }

        this.userChief = null
      }
    },
    computed: {
      // isSuperAdmin: self => self.$store.state.users.user.isSuperAdmin()
    },
    mounted () {
      this.getDepList();
      this.setParent();
    },
    watch: {
      depData: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';


  .dep-create-form-chief {
    margin-bottom: 15px;

    &__name {
      margin-top: 15px;
      font-size: 16px;
      font-weight: 700;
    }

    &__cancel {
      color: $link-color;
      cursor: pointer;
    }
  }

  .dep-create-form-head-org {
    margin-top: 15px;
  }

  .dep-create-form-parents-tree {
    overflow: auto;
    margin-bottom: 15px;

    .el-checkbox {
      &__inner {
        border-radius: 100%;

        &:after {
          width: 4px;
          height: 4px;
          border-radius: 100%;
          border: 0;
          background-color: #fff;
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%) scale(0);
          transition: transform .15s ease-in;
        }
      }

      &__input {
        &.is-checked {
          .el-checkbox__inner::after {
            transform: translate(-50%, -50%) scaleY(1);
          }
        }
      }
    }

    .el-tree-node__content > .el-checkbox {
      margin-bottom: 0;
    }
  }

  .dep-create-form-switcher {
    margin-bottom: 25px;
    color: #a2a2a2;
    display: grid;
    grid-template-columns: 45px 1fr;
    grid-column-gap: 10px;

    &.active {
      color: #3e3e3e;
    }

    &__text {
      cursor: pointer;
    }
  }
</style>